import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-inline: 50px;
  padding-block: 24px;
  gap: 24px;

  @media (max-width: 768px) {
    padding-inline: 16px;
  }
`;

export const InfoContainer = styled.div`
  width: 100%;
  max-width: 1000px;
`;

export const StatsRow = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const StatCard = styled.div`
  flex: 1;
  min-width: 140px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px;
  border-radius: 14px;
  background-color: ${props => props.theme.colors.card};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 4px 24px rgba(0, 0, 0, 0.06);
  border: 1px solid ${props => props.theme.colors.border_grey}30;
`;

export const StatIcon = styled.div<{ color: string }>`
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.color}14;
  color: ${props => props.color};
`;

export const StatLabel = styled.span`
  font-weight: 500;
  font-size: 12px;
  letter-spacing: 0.02em;
  color: ${props => props.theme.colors.grey_text};
`;

export const StatValue = styled.span`
  font-weight: 700;
  font-size: 20px;
  color: ${props => props.theme.colors.text};
  letter-spacing: -0.01em;
`;

export const Card = styled.div`
  margin-top: 20px;
  border-radius: 16px;
  background-color: ${props => props.theme.colors.card};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 4px 24px rgba(0, 0, 0, 0.06);
  border: 1px solid ${props => props.theme.colors.border_grey}30;
  overflow: hidden;
`;

export const GroupSection = styled.div`
  padding: 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${props => props.theme.colors.border_grey}30;
  }
`;

export const GroupHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 28px 8px;
`;

export const GroupName = styled.span`
  font-weight: 600;
  font-size: 15px;
  color: ${props => props.theme.colors.text};
`;

export const ItemRow = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 16px 28px;
  transition: background-color 150ms ease;

  &:hover {
    background-color: ${props => props.theme.colors.hover};
  }
`;

export const ItemImage = styled.div`
  width: 56px;
  height: 56px;
  min-width: 56px;
  border-radius: 12px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ItemDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
  min-width: 0;
`;

export const ItemName = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: ${props => props.theme.colors.text};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ItemMeta = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${props => props.theme.colors.grey_text};

  strong {
    color: ${props => props.theme.colors.text};
    font-weight: 600;
  }
`;

export const SubTotalRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 14px 28px;
  gap: 8px;
  border-top: 1px dashed ${props => props.theme.colors.border_grey}50;
`;

export const SubTotalLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${props => props.theme.colors.grey_text};
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const SubTotalValue = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: ${props => props.theme.colors.text};
  font-variant-numeric: tabular-nums;
`;

